import { render, staticRenderFns } from "./GroupAll.vue?vue&type=template&id=67c50150"
import script from "./GroupAll.vue?vue&type=script&lang=js"
export * from "./GroupAll.vue?vue&type=script&lang=js"
import style0 from "./GroupAll.vue?vue&type=style&index=0&id=67c50150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports